import { AdminTopbar } from "@/components/admin/AdminLayout";
import { ModulePanel, EditorialStatusBadge, DataTable } from "@/components/admin/AdminPrimitives";
import { ARTICLES } from "@/lib/mock-data";
import { useI18n } from "@/lib/i18n";

function Workflow() {
  const { t } = useI18n();

  const STATES = [
    t("admin.workflow.state.draft"),
    t("admin.workflow.state.submitted"),
    t("admin.workflow.state.verifying"),
    t("admin.workflow.state.security"),
    t("admin.workflow.state.translation"),
    t("admin.workflow.state.avatar"),
    t("admin.workflow.state.scheduled"),
    t("admin.workflow.state.published"),
    t("admin.workflow.state.corrected"),
    t("admin.workflow.state.archived"),
  ];

  const TEAMS = [
    t("admin.workflow.team.editorial"),
    t("admin.workflow.team.verif"),
    t("admin.workflow.team.security"),
    t("admin.workflow.team.translation"),
  ];

  return (
    <>
      <AdminTopbar title={t("admin.nav.workflow")} subtitle={t("admin.workflow.subtitle")} />
      <div className="flex-1 overflow-y-auto p-6 space-y-6">
        <ModulePanel title={t("admin.workflow.steps")}>
          <div className="flex flex-wrap gap-2">
            {STATES.map((s, i) => (
              <div key={s} className="flex items-center gap-2">
                <EditorialStatusBadge status={s} />
                {i < STATES.length - 1 && <span className="text-muted-foreground">→</span>}
              </div>
            ))}
          </div>
        </ModulePanel>
        <ModulePanel title={t("admin.workflow.pipeline")}>
          <DataTable
            columns={[t("admin.common.col.title"), t("admin.workflow.col.step"), t("admin.workflow.col.assigned"), t("admin.common.col.updated")]}
            rows={ARTICLES.map((a, i) => [
              <span className="font-medium text-foreground line-clamp-1">{a.title.fr}</span>,
              <EditorialStatusBadge status={STATES[(i + 2) % STATES.length]} />,
              TEAMS[i % 4],
              new Date(a.publishedAt).toLocaleString("fr-FR"),
            ])}
          />
        </ModulePanel>
      </div>
    </>
  );
}

export default Workflow;
